//------------------------------------------------------------------------------
//
// Authentication
//
// SSO will be contacted to populate the currently signed in user in the
// background.
//
//------------------------------------------------------------------------------

import {vuexOidcCreateStoreModule} from "vuex-oidc";
import {OAIDC_SETTINGS} from "../../config/oidc";
import store from "../store";
import router from "../../router";

const authStore = vuexOidcCreateStoreModule(
	OAIDC_SETTINGS,
	{
		namespaced: true
	},
	{
		accessTokenExpiring: () => {
			// Try to refresh the token.
			store.dispatch("authStore/authenticateOidcSilent");
		},
		userSignedOut: () => {
			store.dispatch("authStore/silentLogOut");
		}
	}
);

// Add silent logout action.
authStore.actions["silentLogOut"] = ({ commit, getters }) => {
	// the token only last 15min which is 15*60*1000 = 900000 ms
	const tokenExp = 900000;
	const exp = getters.oidcIdTokenExp;
	// if user has not been login, ignore it
	if (!exp) {
		return;
	}
	// sometimes when user login, a user signed out event has been triggered,
	// this is used to prevent user logout instantly
	// so, if the function is been triggered within 10 seconds of user login event
	// ignore this event
	if (exp - new Date().getTime() > tokenExp - 10000) {
		return;
	}
	commit("unsetOidcAuth");
	router.push("/");
};

export default authStore;
